import type React from 'react';

import type { FieldConfig, FieldType } from '@/types/forms';
import { DatePickerField } from '@/components/forms/FormFields/DatePickerField';
import { EmojiRatingField } from '@/components/forms/FormFields/EmojiRatingField';
import { CheckboxField } from '@/components/forms/FormFields/CheckboxField';
import { RadioGroupField } from '@/components/forms/FormFields/RadioGroupField';
import { TextareaField } from '@/components/forms/FormFields/TextareaField';
import { TextField } from '@/components/forms/FormFields/TextField';
import { MarketingConsentCheckbox } from '@/components/forms/FormFields/MarketingConsentCheckbox';

type SharedProps = {
  name: any;
  label: string;
  required?: boolean;
  control: any;
  error?: string;
  colSpan?: 1 | 2;
};

export const fieldRegistry: Partial<
  Record<
    FieldType,
    (sharedProps: SharedProps, field: FieldConfig) => React.ReactNode
  >
> = {
  text: (sharedProps, field) => (
    <TextField {...sharedProps} type="text" placeholder={field.placeholder} />
  ),
  email: (sharedProps, field) => (
    <TextField {...sharedProps} type="email" placeholder={field.placeholder} />
  ),
  tel: (sharedProps, field) => (
    <TextField {...sharedProps} type="tel" placeholder={field.placeholder} />
  ),
  textarea: (sharedProps, field) => (
    <TextareaField
      {...sharedProps}
      placeholder={field.placeholder}
      maxLength={field.maxLength}
    />
  ),
  radio: (sharedProps, field) => (
    <RadioGroupField
      {...sharedProps}
      options={field.options ?? []}
      appearance={field.appearance}
    />
  ),
  checkbox: (sharedProps, field) => (
    <CheckboxField {...sharedProps} label={field.label} />
  ),
  'emoji-rating': (sharedProps) => <EmojiRatingField {...sharedProps} />,
  'marketing-consent': (sharedProps) => (
    <MarketingConsentCheckbox {...sharedProps} />
  ),
  date: (sharedProps, field) => (
    <DatePickerField
      {...sharedProps}
      placeholder={field.placeholder}
      allowFutureDates={field.allowFutureDates}
    />
  ),
};
